import { ReactNode, Ref } from 'react';
import {
  FieldError,
  Group,
  Input,
  InputProps,
  Label,
  Text
} from 'react-aria-components';

import { Option } from '@/fo/ui/kit/listbox/base';

import { Chip } from '../Chip/Chip';

import { styles } from './ChipsInput.styles';

type BaseInputProps = Omit<InputProps, 'isInvalid'>;

export interface ChipsInputProps<T extends Option> extends BaseInputProps {
  label?: string;
  helperText?: string;
  endAdornment?: ReactNode;
  errorMessage?: string;
  wrapperRef?: Ref<HTMLDivElement>;
  className?: string;
  selectedOptions?: T[];
  onRemoveOption?: (option: T) => void;
  inputValue?: string;
  chipClassName?: string;
}

export function ChipsInput<T extends Option>({
  endAdornment,
  label,
  helperText,
  errorMessage,
  wrapperRef,
  className,
  selectedOptions,
  onRemoveOption,
  inputValue,
  chipClassName,
  ...props
}: ChipsInputProps<T>) {
  const slots = styles();

  return (
    <>
      {label && <Label className={slots.label()}>{label}</Label>}
      <Group
        className={slots.wrapper()}
        ref={wrapperRef}
      >
        {selectedOptions?.map((option) => (
          <Chip
            key={option.value}
            option={option}
            onRemove={() => onRemoveOption?.(option)}
            className={chipClassName}
          />
        ))}
        <div className={slots.inputWrapper()}>
          <Input
            className={slots.input({ class: className })}
            value={inputValue}
            {...props}
          />
          {endAdornment && (
            <div className={slots.endAdornment()}>{endAdornment}</div>
          )}
        </div>
      </Group>
      {helperText && (
        <Text
          slot="description"
          className={slots.helperText()}
        >
          {helperText}
        </Text>
      )}
      <FieldError>{errorMessage}</FieldError>
    </>
  );
}
